import { render, staticRenderFns } from "./MechanicAssetTransferRoute.vue?vue&type=template&id=3252b3ff&scoped=true&"
import script from "./MechanicAssetTransferRoute.vue?vue&type=script&lang=js&"
export * from "./MechanicAssetTransferRoute.vue?vue&type=script&lang=js&"
import style0 from "./MechanicAssetTransferRoute.vue?vue&type=style&index=0&id=3252b3ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3252b3ff",
  null
  
)

export default component.exports